import { Serializable } from './Serializable';

export class KeyDriversDTO extends Serializable {
    id: string;
    title: string;
    image: string;
    optionalTitle: string;
    description: string;
    visibleName: string;
    clientID: string;
    parentID: string;
    
    constructor() {
        super();
    }
    
    isGlobal(): boolean {
        return this.title != null && this.title != '' && this.title != undefined;
    }

}
